export const waveDegreeOptions: Array<{ label: string, value: string }> = [
    { label: 'Supermillennium', value: 'supermillennium' },
    { label: 'Millennium', value: 'millennium' },
    { label: 'Submillennium', value: 'submillennium' },
    { label: 'Grand Supercycle', value: 'grandSupercycle' },
    { label: 'Supercycle', value: 'supercycle' },
    { label: 'Cycle', value: 'cycle' },
    { label: 'Primary', value: 'primary' },
    { label: 'Intermediate', value: 'intermediate' },
    { label: 'Minor', value: 'minor' },
    { label: 'Minute', value: 'minute' },
    { label: 'Minuette', value: 'minuette' },
    { label: 'Subminuette', value: 'subminuette' },
    { label: 'Micro', value: 'micro' },
    { label: 'Submicro', value: 'submicro' },
    { label: 'Minuscule', value: 'minuscule' }
]